module.exports = __webpack_public_path__ + "img/founder_slip.7a3fa506.png";